// extracted by mini-css-extract-plugin
export default {"container":"p2-z","list":"q2-z"};